import { SpecificQueryType } from 'components/shared/interfaces/SpecificQueryTypes';
import {
  DitaQueryDetailsFragment,
  NonAbapQueryDetailsFragment,
  TrainingQueryDetailsFragment,
  CorporateContentQueryDetailsFragment,
  AbapQueryDetailsFragment,
  NotesQueryDetailsFragment,
  MarketingQueryDetailsFragment
} from 'generated/graphql';
import { forwardRef } from 'react';
import { DisplayQueryDetailsDita } from './DisplayQueryDetailsDita';
import { DisplayQueryDetailsNonAbap } from './DisplayQueryDetailsNonAbap';
import { DisplayQueryDetailsTraining } from './DisplayQueryDetailsTraining';
import { DisplayQueryDetailsCorporateContent } from './DisplayQueryDetailsCorporateContent';
import { DisplayQueryDetailsABAP } from './DisplayQueryDetailsABAP';
import { DisplayQueryDetailsNotes } from './DisplayQueryDetailsNotes';
import { DisplayQueryDetailsMarketing } from './DisplayQueryDetailsMarketing';

type QueryDetails =
  | null
  | DitaQueryDetailsFragment
  | NonAbapQueryDetailsFragment
  | TrainingQueryDetailsFragment
  | CorporateContentQueryDetailsFragment
  | AbapQueryDetailsFragment
  | NotesQueryDetailsFragment
  | MarketingQueryDetailsFragment;

export interface DisplayQueryDetailsProps {
  queryId: string;
  queryDetails?: QueryDetails;
}

export const DisplayQueryDetails = forwardRef<SpecificQueryType, DisplayQueryDetailsProps>(
  (props, ref) => {
    const { queryDetails, queryId } = props;
    switch (queryDetails?.__typename) {
      case 'DitaQuery':
        return <DisplayQueryDetailsDita queryDetails={queryDetails} queryId={queryId} ref={ref} />;
      case 'NonAbapQuery':
        return (
          <DisplayQueryDetailsNonAbap queryDetails={queryDetails} queryId={queryId} ref={ref} />
        );
      case 'TrainingQuery':
        return (
          <DisplayQueryDetailsTraining queryDetails={queryDetails} queryId={queryId} ref={ref} />
        );
      case 'CorporateContentQuery':
        return (
          <DisplayQueryDetailsCorporateContent
            queryDetails={queryDetails}
            queryId={queryId}
            ref={ref}
          />
        );
      case 'AbapQuery':
        return <DisplayQueryDetailsABAP queryDetails={queryDetails} queryId={queryId} ref={ref} />;
      case 'NotesQuery':
        return <DisplayQueryDetailsNotes queryDetails={queryDetails} queryId={queryId} ref={ref} />;
      case 'MarketingQuery':
        return (
          <DisplayQueryDetailsMarketing queryDetails={queryDetails} queryId={queryId} ref={ref} />
        );
    }
    return null;
  }
);
